import {component_tool,utils_tool} from '@/tool';
import React from 'react'
import {WizTableForm} from '@/containers/common';
import moment from "moment";
const { WizModal } = component_tool;
let {$$, checkStrLength} = utils_tool;

const organizationConfig = WizTableForm.Config.organization(this, {
  apiParams: {
    state: 1,
    organizationNodeCategory: ["2"]
  }
})
//配置项
let componentName = 'storeReport'


const formatterDateTime = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm:ss') : '';
}

const columns = [
  {
    name: "id",
    formItem: {
      type: "hidden"
    }
  },
  {
    title: "品牌",
    name: "brandId",
    searchItem: {
      diy: WizTableForm,
      selectType: "radio",
      ...organizationConfig
    }
  },
  {
    title: '品牌',
    name: 'brandName',
    tableItem: {width: 150}
  },
  {
    title: "类型",
    name: "importType",
    dataIndex: "importType",
    dict: [
      {code: 0, codeName: "销售"},
      {code: 1, codeName: "售后"},
    ],
    tableItem: {
      width: 150
    },
    searchItem: {
      type: "select",
    },
  },
  {
    title: "文件名称",
    name: "importName",
    tableItem: {
      width: 200
    },
    searchItem: {}
  },
  {
    title: "状态",
    name: "state",
    dataIndex: "state",
    dict: [
      {code: 0, codeName: "禁用"},
      {code: 1, codeName: "启用"},
    ],
    searchItem: {
      type: "select",
    },
    tableItem: {
      width: 150
    },
  },
  {
    title: '导入时间',
    name: 'importTime',
    tableItem: {
      render: (text, record) => {
        return formatterDateTime(text)
      }
    }
  }
];

const templateConfig = (data) => {
  const {_downloadFile, _this} = data;
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns,
        searchBarProps: {
          cols: {
            xs: 12,
            md: 12,
            xl: 12
          },
          collapse: false,
          buttonSort: ['import'],
          buttons: [
            {
              key: "import",
              custom: true,
              params: {children: "导入单店报告"},
              customOnClick: {
                key: "jumpPage",
                params: {
                  key: "push",
                  pathname: "/storeReport/storeReportList/import"
                }
              }
            },
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          // selectType: "checkbox",
          isScroll: true,
          loading: false,
        },
        rowOperateSort: ['look', 'enableOrDisable', 'download'],
        rowOperateView: [
          {
            key: "look",
            custom: true,
            params: {children: "查看"},
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/storeReport/storeReportList/record"
              }
            }
          },
          {
            key: "enableOrDisable",
            custom: true,
            params: {children: "启用"},
            textFormat: {
              recordKey: 'state',
              dirt: {0: '启用', 1: '禁用'}
            },
            customOnClick: {
              key: "action",
              params: {
                apiKey: "updateState",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                let statusNameStr = record['state'] === 0 ? "启用" : "禁用";
                const content = `您确定要` + statusNameStr + `该报告吗？`;
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      state: record['state'] === 0 ? 1 : 0,
                      id: record['id']
                    })
                  },
                  onCancel() {
                  }
                });
                return null
              }
            }
          },
          {
            key: "download",
            name: "WizButton",
            params: {
              children: "下载文件",
              key: "_btn",
            },
            onClick: e => _downloadFile && _downloadFile(e),
            recordChangeParams: ({record, rows}) => {
              let disabled = true;
              if (record && record.fileId != undefined && record.fileId != '' && record.fileId != null) {
                disabled = false;
              }
              return {disabled}
            }
          },
        ],
        commonOperate: {
          add: true,
          update: true
        }
      }
    }
  };
};

const apis = {
  list: {
    path: `${componentName}/pageList`,
    payload: {
      key: `${componentName}@pageList`,
      apiParams: {pageNum: 1, pageSize: 10}
    }
  },
  updateState: {
    path: `${componentName}/updateState`,
    payload: {
      key: `${componentName}@updateState`,
      apiParams: {}
    }
  },
}


let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export {reduxTemplateCofig, templateConfig};
